import axios from "axios";
import { getHeaders } from "../utility/getHeader";

/**
 * Cancels a record by updating its status to '2' and creates reverse ledger entries
 * 
 * @param {string} tablename - Name of the table
 * @param {string} colname - Name of the identifying column (e.g., "id")
 * @param {string|number} colval - Value of the identifying column
 */
const updateRecord = async (tablename, colname, colval) => {
  try {
    if (!tablename || !colname || colval === undefined || colval === null) {
      console.error("Invalid arguments passed to cancelRecord");
      return;
    }

    // If cancelling a bill (final_bill table), create reverse ledger entries
    if (tablename === "final_bill" || tablename === "advance_final_bill") {
      try {
        // Fetch the bill details first
        const billResponse = await axios.get(
          `/fetchdata/${tablename}/id/${colval}`,
          getHeaders()
        );

        if (billResponse.data && billResponse.data.length > 0) {
          const bill = billResponse.data[0];
          
          // Fetch existing ledger entries for this transaction
          const ledgerResponse = await axios.get(
            `/fetchdata/ledger_entries/transaction_id/${colval}`,
            getHeaders()
          );

          if (ledgerResponse.data && ledgerResponse.data.length > 0) {
            const existingEntries = ledgerResponse.data;
            
            // Create reverse ledger entries (swap debit and credit)
            const reverseLedgerEntries = existingEntries.map(entry => ({
              transaction_id: `${colval}-CANCEL`,
              date: new Date().toISOString(),
              account_type: entry.account_type,
              account_id: entry.account_id,
              description: `Bill #${colval} - Cancellation (Reversal)`,
              debit_amount: parseFloat(entry.credit_amount || 0),
              credit_amount: parseFloat(entry.debit_amount || 0),
              reference_id: colval
            }));

            // Insert reverse ledger entries
            for (const entry of reverseLedgerEntries) {
              await axios.post(
                '/insertdata/ledger_entries',
                entry,
                getHeaders()
              );
            }

            console.log(`Created ${reverseLedgerEntries.length} reverse ledger entries for bill #${colval}`);
          }
        }
      } catch (ledgerError) {
        console.error("Error creating reverse ledger entries:", ledgerError.message);
        // Continue with cancellation even if ledger reversal fails
      }
    }

    // Update the record status to '2' (cancelled)
    const payload = {
      updatedFields: { status: "2" },
      where: { [colname]: colval },
    };

    const res = await axios.put(
      `/updatedata/${tablename}`,
      payload,
      getHeaders()
    );

    console.log("Cancelled:", res.data);
  } catch (err) {
    console.error("Cancel Error:", err.message);
    throw err;
  }
};

export default updateRecord;
